import { isUpcomingCancel } from '../helpers';

const CancelMembership = (props) => {
  const { clubMembership, onModal } = props;

  const handleCancel = (e) => {
    e.preventDefault();
    onModal('cancel');
  };

  if (isUpcomingCancel(clubMembership)) {
    return null;
  }
  return (
    <>
      <span className="c7-club-actions__divider" />
      <a onClick={handleCancel} className="c7-club-actions__cancel">
        Cancel club
      </a>
    </>
  );
};

export default CancelMembership;
